import { render, staticRenderFns } from "./FreeCurationsButtons.vue?vue&type=template&id=3b7e9481&scoped=true&"
import script from "./FreeCurationsButtons.vue?vue&type=script&lang=js&"
export * from "./FreeCurationsButtons.vue?vue&type=script&lang=js&"
import style0 from "./FreeCurationsButtons.vue?vue&type=style&index=0&id=3b7e9481&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e9481",
  null
  
)

export default component.exports